import React, { lazy, Suspense, useEffect, useState } from "react";

const DemoTour = lazy(() => import("./DemoTour"));

// Ne charge le chunk du parcours guidé QUE si une visite est active (zéro impact site public)
export default function DemoTourGate() {
  const [on, setOn] = useState(() => {
    try { return !!sessionStorage.getItem("demo_tour"); } catch { return false; }
  });
  useEffect(() => {
    const h = () => { try { setOn(!!sessionStorage.getItem("demo_tour")); } catch { /* noop */ } };
    window.addEventListener("demo:tour", h);
    return () => window.removeEventListener("demo:tour", h);
  }, []);
  if (!on) return null;
  return <Suspense fallback={null}><DemoTour /></Suspense>;
}
